import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";
import { UserMgmtService } from "../user.service";

@Component({
  selector: "app-user-detail",
  templateUrl: "./user-detail.component.html",
  styleUrls: ["./user-detail.component.scss"],
})
export class UserDetailComponent implements OnInit, OnDestroy {
  isLoading = false;
  userId: string;
  userDetails: any = null;

  private sub: Subscription;

  constructor(private route: ActivatedRoute, private userMgmtService: UserMgmtService) {}

  ngOnInit() {
    this.sub = this.route.params.subscribe((params) => {
      this.userId = params["id"];
      if (this.userId) {
        this.fetchUserDetails(this.userId);
      }
    });
  }

  fetchUserDetails(id: string) {
    this.isLoading = true;
    this.userDetails = null;

    // Reuse existing API already used in `view-user` to fetch user by id.
    this.userMgmtService.getUserListApi("userId=" + id).subscribe(
      (res) => {
        this.isLoading = false;
        if (res && res["message"] === "Success") {
          var list = (res && res["data"] && res["data"]["userList"]) || [];
          this.userDetails = list && list.length ? list[0] : null;
        } else {
          this.userDetails = null;
        }
      },
      () => {
        this.isLoading = false;
        this.userDetails = null;
      }
    );
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}

